import React, { useState, useEffect } from "react";
import "./News.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";

/* IMPORT NEWS IMAGES */
import n1 from "../../Asset/Images/ne1.jpeg";
import n2 from "../../Asset/Images/ne2.jpeg";
import n3 from "../../Asset/Images/ne3.jpeg";
import n4 from "../../Asset/Images/ne4.jpeg";
import n5 from "../../Asset/Images/ne5.jpeg";
import n6 from "../../Asset/Images/ne6.jpeg";
import n7 from "../../Asset/Images/fly6.jpeg";
import n8 from "../../Asset/Images/fly9.jpeg";
import n9 from "../../Asset/Images/fly3.jpeg";
import n10 from "../../Asset/Images/fly4.jpeg";
import n11 from "../../Asset/Images/fly7.jpeg";
import n12 from "../../Asset/Images/fly1.jpeg";
import n13 from "../../Asset/Images/fly15.jpeg";
import n14 from "../../Asset/Images/fly5.jpeg";
import n15 from "../../Asset/Images/fly2.jpeg";

const newsImages = [
  n1, n2, n3, n4, n5, n6, n7, n8, n9, n10, n11, n12, n13, n14, n15
];

const News = () => {
  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true
    });
  }, []);

  return (
    <div className="news_page">
      <h1 className="gallery_title">
        {t('news.title_start')} <span>{t('news.title_end')}</span>
      </h1>

      <p className="gallery_subtitle">
        {t('news.subtitle')}
      </p>

      <div className="news_grid">
        {newsImages.map((img, index) => (
          <div
            className="news_card"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 40}
            onClick={() => setActiveImage(img)}
          >
            <img src={img} alt={`news-${index}`} loading="lazy" />
            <div className="news_overlay">
              <button className="open_btn">
                {t('news.open_btn')}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* POPUP IMAGE */}
      {activeImage && (
        <div className="news_popup" onClick={() => setActiveImage(null)}>
          <div className="news_modal" onClick={(e) => e.stopPropagation()}>
            <button className="close_btn" onClick={() => setActiveImage(null)}>
              <FaTimes />
            </button>
            <img src={activeImage} alt="news-fullview" />
          </div>
        </div>
      )}
    </div>
  );
};

export default News;